"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeEncryptedShareBlob = exports.encodeShareBlob = exports.copyDefaultShareLink = exports.writeClipboard = exports.buildShareUrl = exports.buildPlainShareUrl = void 0;
const shareEncoding_1 = require("./shareEncoding");
Object.defineProperty(exports, "encodeShareBlob", { enumerable: true, get: function () { return shareEncoding_1.encodeShareBlob; } });
Object.defineProperty(exports, "encodeEncryptedShareBlob", { enumerable: true, get: function () { return shareEncoding_1.encodeEncryptedShareBlob; } });
const buildPlainShareUrl = (encoded) => {
    const url = new URL(window.location.href);
    url.search = '';
    url.hash = 'n=' + encoded;
    return url.toString();
};
exports.buildPlainShareUrl = buildPlainShareUrl;
const buildShareUrl = (encoded, encrypted, title = '', message = '') => {
    const url = new URL(window.location.href);
    url.search = '';
    const params = new URLSearchParams();
    params.set(encrypted ? 'e' : 'n', encoded);
    if (title.trim())
        params.set('t', title.trim());
    if (message.trim())
        params.set('m', message.trim());
    url.hash = params.toString();
    return url.toString();
};
exports.buildShareUrl = buildShareUrl;
const writeClipboard = async (text) => {
    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return;
    }
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
        document.execCommand('copy');
    }
    finally {
        document.body.removeChild(textarea);
    }
};
exports.writeClipboard = writeClipboard;
const copyDefaultShareLink = async (bytes) => {
    const encoded = await (0, shareEncoding_1.encodeShareBlob)(bytes);
    const url = (0, exports.buildPlainShareUrl)(encoded);
    await (0, exports.writeClipboard)(url);
    return url;
};
exports.copyDefaultShareLink = copyDefaultShareLink;
